// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__1osGS"};